const legacyLevelKey = gameType =>
  gameType === "doubles" ? "gameLevelDouble" : "gameLevelSingle"

const isScalar = value => value !== null && typeof value !== "object"

export const getParticipantGameLevel = (participant, gameType) => {
  const gameLevel = participant?.gameLevel

  return participant?.[legacyLevelKey(gameType)] ??
    gameLevel?.[gameType] ??
    (isScalar(gameLevel) ? gameLevel : undefined) ??
    participant?.level
}
